import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { CustomNavigate } from '@/components/functional/Link/CustomNavigate/CustomNavigate';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { CustomRoute } from '@/components/functional/Link/CustomRoute';
import { CustomRoutes } from '@/components/functional/Link/CustomRoutes';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { ContactConsultation } from '@/pages/contact/consultation/ContactConsultation';
import { ContactConsultationComplete } from '@/pages/contact/consultation/ContactConsultationComplete';
import { ContactConsultationConfirm } from '@/pages/contact/consultation/ContactConsultationConfirm';
import { isClient } from '@/utils/resources/auth/authResource';
import { clientMyPageConsultationPath } from '@/utils/router/links';
import { pagePath, getChildPath } from '@/utils/router/pagePath';
const contactPath = pagePath.contact;
const rootPath = pagePath.contact.consultationRoot();
/**
 * コンサル選定のご相談のアクセスルーティング用
 */
export const ContactConsultationRoot = () => {
    const { month, year } = useMemo(() => {
        const now = new Date();
        const y = now.getFullYear();
        const m = now.getMonth() + 1;
        return {
            month: m,
            year: y,
        };
    }, []);
    const [formState, changeFormState] = useState(null);
    const resetFormState = useCallback(() => {
        changeFormState(null);
    }, [changeFormState]);
    const { auth } = useTypeSelector((rootState) => ({
        auth: rootState.auth,
    }));
    const isClientUser = isClient(auth);
    if (isClientUser) {
        return _jsx(CustomRedirect, { to: clientMyPageConsultationPath() });
    }
    return (_jsxs(CustomRoutes, { children: [_jsx(CustomRoute, { element: _jsx(ContactConsultation, { changeFormState: changeFormState, formState: formState, month: month, year: year }), index: true, path: getChildPath(contactPath.consultation(), rootPath) }), "s", _jsx(CustomRoute, { element: _jsx(ContactConsultationConfirm, { formState: formState }), path: getChildPath(contactPath.consultationConfirm(), rootPath) }), _jsx(CustomRoute, { element: _jsx(ContactConsultationComplete, { resetFormState: resetFormState }), path: getChildPath(contactPath.consultationComplete(), rootPath) }), _jsx(CustomRoute, { element: _jsx(CustomNavigate, { to: pagePath.notfound() }), path: '*' })] }));
};
